<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content c-top">
      <h2>优惠券管理</h2>
      <h3>数据筛选</h3>
      <div>
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-form-item label="优惠券名称" prop="name">
            <el-input v-model="searchForm.name" placeholder="请输入优惠券名称"></el-input>
          </el-form-item>

          <el-form-item label="优惠券类型" prop="typeFlag">
            <el-select v-model="searchForm.typeFlag" placeholder="请选择优惠券类型" filterable clearable>
              <el-option v-for="item in this.dictionaries.coupon_type" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="绑定上级" prop="bindUserInfo">
            <el-input v-model="searchForm.bindUserInfo" placeholder="请输入绑定上级"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList('search')">查询</el-button>
            <el-button type="primary" plain @click="getList('reset')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <div style="display: flex; align-items: center;justify-content: space-between;">
          <h3>列表数据</h3>
          <div style="display:flex">
            <div class="u-btn" @click="deleteS('lotsof')">批量删除</div>
            <div class="c-btn" @click="fCoupon()">发放优惠券</div>
            <el-button type="primary" @click="add('add')" icon="el-icon-plus" size="small">新增</el-button>
          </div>
        </div>
      </div>
      <div id="base-list">
        <lb-table v-loading="loading" v-horizontal-scroll="'always'" :column="columns" :data="list" pagination
          :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="searchForm.pageNo" :page-size="searchForm.pageSize" @selection-change="onMultipleSelection"
          @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
      <el-dialog title="温馨提示" :visible.sync="isD" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
        <template>
          <div class="info" style="text-align: left" v-if="isSingle != 'single'">
            <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
            是否确认删除选中的{{ deleteIds.length }}个优惠券？
          </div>
          <div class="info" style="text-align: left" v-else>
            <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
            是否确认删除该优惠券？
          </div>
          <div style="display: flex; justify-content: end; margin-top: 24px">
            <div class="info-q" @click="isD = false">取消</div>
            <div class="info-s" @click="submitD">确定</div>
          </div>
        </template>
      </el-dialog>
      <el-dialog title="生成二维码" :visible.sync="isQcode" width="518px" :append-to-body="true">
        <template>
          <div style="margin-left: 139px;">
            <img :src="qCode" style="width: 200px;height: 200px;" />
          </div>
          <div style="display: flex; justify-content: end; margin-top: 24px">
            <div class="info-s"><a :href="qCode" style="color:white;text-decoration: none;">导出</a>
            </div>
          </div>
        </template>
      </el-dialog>
      <el-dialog title="发放优惠券" :visible.sync="isCoupon" width="60%" :append-to-body="true">
        <template>
          <div>
            <el-radio-group v-model="couponForm.userSelectType" @change="selectType">
              <el-radio-button label="0">用户发放</el-radio-button>
              <el-radio-button label="1">层级发放</el-radio-button>
            </el-radio-group>
          </div>
          <div style="display: flex;margin-top: 24px;" v-if="couponForm.userSelectType == 0">
            <div class="dialog-search" style="display: flex;">
              <div>
                <el-input placeholder="请输入用户信息" clearable v-model="keywords" style="width: 232px;"
                  size="small"></el-input>
              </div>
              <div style="margin-left: 20px;">
                <el-button type="primary" @click="getfindVipCustomerPage" size="small">查询</el-button>
              </div>
            </div>
          </div>
          <div style="display: flex;" v-if="couponForm.userSelectType == 0">
            <div style="width: 48%;">
              <el-table :data="tableData" tooltip-effect="dark" row-key="id" ref="multipleTable"
                :header-cell-style="{ 'background': '#f8f8f8', 'color': '#333333' }"
                @selection-change="handleSelectionChange" style="width: 100%; margin-top: 20px;">
                <el-table-column type="selection" :reserve-selection="true" width="55">
                </el-table-column>
                <el-table-column label="用户ID" prop="id"> </el-table-column>
                <el-table-column label="用户昵称" prop="name">
                </el-table-column>
                <el-table-column prop="phone" label="手机号码" show-overflow-tooltip>
                </el-table-column>
              </el-table>
              <div style="margin-top: 10px">
                <el-pagination style="text-align: center;" @size-change="cHandleSizeChange"
                  @current-change="cHandleCurrentChange" :current-page="cPageNo" :page-sizes="[10, 20, 30, 40]"
                  :page-size="cPageSize" layout="prev, pager, next" :total="cTotalNum">
                </el-pagination>
              </div>
            </div>
            <div style="width: 10px;margin-left: 10px;">
              <div style="width:0px;height: 100%;border: 1px solid #EBEBFA;opacity: 1;"></div>
            </div>
            <div style="width: 48%;">
              <div
                style="height: 21px;font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;line-height: 21px;color: #303033;">
                已选用户（{{ tableData1.length || 0 }}）</div>
              <el-table :data="pageData" tooltip-effect="dark"
                :header-cell-style="{ 'background': '#f8f8f8', 'color': '#333333' }"
                style="width: 100%; margin-top: 20px;">
                <el-table-column label="用户ID" prop="id"> </el-table-column>
                <el-table-column label="用户昵称" prop="name">
                </el-table-column>
                <el-table-column prop="phone" label="手机号码" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="phone" label=" ">
                  <template slot-scope="scope">
                    <div style="text-align: center;" @click="del(scope.$index, scope.row)">
                      <img src="../../../assets/icon_del_nor.png" style="width:20px;height: 20px;" />
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 10px">
                <el-pagination style="text-align: center;" @size-change="cHandleSizeChange1"
                  @current-change="cHandleCurrentChange1" :current-page="cPageNo1" :page-size="cPageSize1"
                  layout="prev, pager, next" :total="tableData1.length">
                </el-pagination>
              </div>
            </div>
          </div>
          <div v-if="form.userSelectType == 1" style="margin-top:30px;font-size: 24px;">
            <el-form :rules="rules" ref="couponForm" :model="couponForm" style="margin-top: 20px;">
              <el-form-item label="用户层级" prop="vipIds" style="margin-top: 20px;">
                <div style="display: flex;">
                  <el-checkbox-group v-model="couponForm.vipIds" @change="changeVip">
                    <el-checkbox v-for="(item, index) in grades" :label="item.id" :key="item.id">{{ item.name
                    }}</el-checkbox>
                  </el-checkbox-group>

                  <!-- <div v-for="(item, index) in grades" :key="index" style="margin-right: 40px;">

                  </div> -->
                </div>

              </el-form-item>
            </el-form>
          </div>
          <el-form :rules="rules" ref="couponForm" :model="couponForm" style="margin-top: 20px;">
            <el-form-item label="发放卡券" prop="couponId" style="margin-top: 20px;">
              <el-select v-model="couponForm.couponId" placeholder="请选择卡券" filterable clearable style="width:348px">
                <el-option v-for="item in coupons" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发放数量" prop="num" style="margin-top: 20px;">
              <el-input v-model.number="couponForm.num" placeholder="请输入发放数量" style="width:348px">
              </el-input>
            </el-form-item>
          </el-form>
          <div style="display: flex; justify-content: end; margin-top: 24px">
            <div class="info-q" @click="isCoupon = false">取消</div>
            <div class="info-s" @click="submitC">确定</div>
          </div>
        </template>
      </el-dialog>
    </div>

  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    LbTable
  },
  data() {
    return {
      grades: [
        {
          checked: true,
          name: 'VIP钻石',
          id: '1'
        },
        {
          checked: true,
          name: 'VIP铂金',
          id: '2'
        },
        {
          checked: true,
          name: 'VIP白银',
          id: '3'
        },
        {
          checked: true,
          name: 'VIP粉丝',
          id: '4'
        }, {
          checked: true,
          name: '普通用户',
          id: '5'
        }
      ],
      couponForm: {
        couponId: '',
        num: null,
        userSelectType: '0',
        vipIds: []
      },
      rules: {
        couponId: [
          { required: true, message: '请选择发放卡券', trigger: 'blur' }
        ],
        num: [
          { required: true, message: '请输入发放数量', trigger: 'blur' }
        ],
        vipIds: [
          { required: true, message: '请选择用户层级', trigger: 'blur' }
        ]
      },

      coupons: [],
      keywords: '',
      tableData: [],
      tableData1: [],
      form: {
        userSelectType: '0'
      },
      isCoupon: false,
      isQcode: false,
      qCode: '',
      isD: false,
      dataList: {
        list: [
          { title: '营销管理', path: '', type: '0' },
          { title: '优惠券管理', path: '', type: '1' }
        ]
      },
      searchForm: {
        name: '',
        typeFlag: '',
        pageNo: 1,
        pageSize: 10,
        bindUserInfo: null
      },
      openTime: [],
      statuss: [
        {
          id: '1',
          name: '已启用'
        },
        {
          id: '0',
          name: '已禁用'
        }
      ],
      list: [
        {
          name: '天兰',
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        }
      ],
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },
        { label: 'ID', prop: 'id', minWidth: '120' },
        { label: '优惠券类型', prop: 'typeLabel', minWidth: '120' },
        { label: '是否显示', prop: 'showFlagL', minWidth: '120' },
        {
          label: '适用商品范围', prop: 'scopeLabel', minWidth: '210',
          render: (h, scope) => {
            let v = ''
            if (scope.row.scopeLabel) {
              v = <div style="width:100%;text-align:left;max-height: 120px;line-height:30px;overflow: hidden;text-overflow: ellipsis;word-break: break-all;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;">
                {
                  scope.row.scopeLabel
                }
              </div>
            } else {
              v = '--'
            }
            return (
              <div style="display:flex;justify-content:space-between;align-items:center">
                <div>{v}</div>
              </div >

            )
          }
        },
        {
          label: '绑定上级', prop: 'scopeLabel', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.bindUserName ? scope.row.bindUserName : '--'}</p>
                <p>{scope.row.bindUserPhone ? scope.row.bindUserPhone : '--'}</p>
              </div>
            )
          }
        },
        { label: '优惠券使用用户', prop: 'userScopeLabel', minWidth: '150' },
        { label: '优惠券名称', prop: 'name', minWidth: '200' },
        { label: '优惠券价值', prop: 'value', minWidth: '120' },

        { label: '数量', prop: 'quantity', minWidth: '120', },
        { label: '开始时间', prop: 'startTime', minWidth: '200' },
        {
          label: '结束时间', prop: 'endTime', minWidth: '200',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.endTime ? scope.row.endTime : '--'}</p>
              </div>
            )
          }
        },
        {
          label: '操作',
          minWidth: '180',
          fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.add('look', scope.row.id) }}>查看/编辑</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.lookQCode(scope.row.qrInfo, scope.row.qrInfoDown) }}>生成二维码</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.deliveDetail(scope.row.id) }}>领券详情</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.deleteS('single', scope.row.id) }}>删除</span>
                {/* <el-link size='mini' type='primary' onClick={() => { this.add('edit', scope.row.id) }}>查看</el-link>
                <el-link size='mini' type='primary' onClick={() => { this.add('use', scope.row.id) }}>使用详情</el-link>
                <el-link size='mini' type='primary' onClick={() => { this.add('receive', scope.row.id) }}>领取详情</el-link> */}
              </div>
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      categoryList: [],
      dictionaries: {},
      loading: false,
      isSingle: 'single',
      deleteIds: [],
      selectionCoupons: [],
      qrInfo: '',
      qUrl: '',
      qrInfoDown: '',
      cPageNo: 1,
      cPageSize: 6,
      cTotalNum: 0,
      cPageNo1: 1,
      cPageSize1: 6,
      selectTemArr: [],
      pageData: []
    }
  },
  created() {
    //   this.getCategoryList()
    this.getDictionaries('coupon_type')
    this.getLevel()
    this.getList()
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == 'couponDetail') {
      next(vm => {
        vm.getList();
      });
    } else {
      next(vm => {
        vm.getList();
      });
    }
  },
  mounted() {

  },
  methods: {
    changeVip(val) {
      this.couponForm.vipIds = val
      console.log(this.couponForm.vipIds)
      this.$refs.couponForm.clearValidate('vipIds')
    },
    getLevel() {
      this.axios.get('/vip/level/getUserLevelDataList')
        .then(res => {
          console.log('等级', res)
          if (res.code == 0) {
            this.grades = res.data
          }
        })
    },
    submitC() {
      this.$refs['couponForm'].validate((valid) => {
        if (valid) {
          let userIds = []
          this.tableData1.forEach(item => {
            userIds.push(item.id)
          })
          let data = {
            userSelectType: this.couponForm.userSelectType,
            couponId: this.couponForm.couponId,
            num: this.couponForm.num,
            userIds: userIds,
            vipIds: this.couponForm.vipIds
          }
          this.axios.post('/coupon/batchDistribute', data)
            .then(res => {
              console.log(res)
              if (res.code == 0) {
                this.$message.success('发放成功')
                this.isCoupon = false
              }
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    del(index, row) {
      this.tableData1.splice(index, 1)
      let arr = []
      arr.push(row)
      arr.forEach((item) => {
        this.$refs.multipleTable.toggleRowSelection(item, false);
      });
      // this.$nextTick(() => {
      //   this.tableData.forEach(item => {
      //     if (item.id == row.id) {
      //       this.$refs.multipleTable.toggleRowSelection(item, false)
      //     }

      //   })
      // })
      this.pageData = this.queryByPage()
    },
    getfindVipCustomerPage() {
      this.cPageNo = 1
      this.getUser()
    },
    // 实现分页的方法
    queryByPage() {
      // 起始位置 = (当前页 - 1) x 每页的大小
      const start = (this.cPageNo1 - 1) * this.cPageSize1
      // 结束位置 = 当前页 x 每页的大小
      const end = this.cPageNo1 * this.cPageSize1

      return this.tableData1.slice(start, end)
    },
    handleSelectionChange(val) {
      console.log(val)
      // this.tableData1 = Array.from(new Set(val.concat(this.tableData1)))
      this.tableData1 = val.reverse()
      this.pageData = this.queryByPage()
    },
    cHandleCurrentChange1(currentChange) {
      this.cPageNo1 = currentChange
      this.pageData = this.queryByPage()
    },
    cHandleSizeChange1(sizeChange) {
      this.cPageSize1 = sizeChange
      this.pageData = this.queryByPage()
    },
    selectType(val) {
      this.form.userSelectType = val
    },
    fCoupon() {
      this.isCoupon = true
      this.keywords = ''
      this.tableData1 = []
      this.pageData = this.queryByPage()
      this.$nextTick(() => {
        this.tableData.forEach(item => {
          this.$refs.multipleTable.toggleRowSelection(item, false)
        })

      })
      this.couponForm.couponId = ''
      this.couponForm.num = ''
      this.getUser()
      this.axios.get('/coupon/getCouponAndNum').then(res => {
        if (res.code == 0) {
          // res.data.list.forEach(item => {
          //   if (item.showFlag == 1) {
          //     item.showFlagL = '是'
          //   } else {
          //     item.showFlagL = '否'
          //   }
          // })
          this.coupons = res.data
        }
      })
    },
    getUser() {
      this.axios.get('/user/search/list?keywords=' + this.keywords + '&pageNo=' + this.cPageNo + '&pageSize=' + this.cPageSize).then(res => {
        if (res.code == 0) {
          if (res.data.list.length > 0) {
            this.tableData = res.data.list
            this.cTotalNum = res.data.totalNum
          } else {
            this.tableData = []
            this.cTotalNum = 0
          }
        }
      })
    },
    deliveDetail(id) {
      this.$router.push({
        name: 'receiveDetail',
        query: {
          id: id
        }
      })
    },
    exportPng() {
      this.axios.get('/coupon/getCouponQrInfoDown?qrInfo=' + encodeURI(this.qrInfo)).then(res => {
        if (res.code == 0) {
          // this.qCode = res.data.url
        }
      })
    },
    lookQCode(qrInfo, qrInfoDown) {
      this.qrInfo = qrInfo
      this.qrInfoDown = qrInfoDown

      this.axios.post('/coupon/getCouponQrInfo', { qrInfo: qrInfo }).then(res => {
        if (res.code == 0) {
          this.isQcode = true
          this.qCode = res.data.url
        }
      })
    },
    deleteS(type, id) {

      this.isSingle = type
      this.deleteIds = []
      if (this.isSingle == 'single') {
        this.isD = true
        this.deleteIds.push(id)
      } else {

        if (this.selectionCoupons.length == 0) {
          this.$message.warning('请选择优惠券')
        } else {
          this.isD = true
          this.selectionCoupons.forEach(item => {
            this.deleteIds.push(item.id)
          })
        }
      }
    },
    submitD() {
      let data = {
        ids: this.deleteIds
      }
      this.axios.post('/coupon/delete', data).then(res => {
        if (res.code == 0) {
          this.isD = false
          this.$message.success('删除成功')
          this.getList()
        }
      })
    },
    //导出
    deriveDeliver() {
      this.$api.exportPlatformsList(this.searchForm).then(res => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
        }
      })
    },
    downloadlink(url) {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = url
      document.body.appendChild(iframe)
    },
    onChangeCategory() {

    },
    onMultipleSelection(val) {
      this.selectionCoupons = val
    },
    handleCurrentChange(currentChange) {
      this.searchForm.pageNo = currentChange
      this.getList()
    },
    handleSizeChange(sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.getList()
    },
    cHandleCurrentChange(currentChange) {
      this.cPageNo = currentChange
      this.getUser()
    },
    cHandleSizeChange(sizeChange) {
      this.cPageSize = sizeChange
      this.getUser()
    },
    getList(type) {
      if (type == 'reset') {
        this.searchForm = {}
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      if (type == 'search') {
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      this.axios.post('/coupon/pageList', this.searchForm).then(res => {
        if (res.code == 0) {
          res.data.list.forEach(item => {
            if (item.showFlag == 1) {
              item.showFlagL = '是'
            } else {
              item.showFlagL = '否'
            }
          })
          this.list = res.data.list
          this.page.totalNum = res.data.totalNum
          this.loading = false;
        }
      })
    },
    // 获取字典数据
    getDictionaries(type) {
      const params = { groupId: type }
      this.axios.get('/getDictGroup?groupId=' + type).then((res) => {
        this.dictionaries['coupon_type'] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取类目列表
    getCategoryList() {
      const params = {}
      this.$api.categoryList(params).then((res) => {
        res.data.list.forEach(item => {
          if (item.children) {
            item.children.forEach(itm => {
              if (itm.children) {
                delete itm.children
              }
            })
          }
        })
        this.categoryList = res.data.list
      }).catch((err) => {
        console.log(err)
      })
    },
    add(type, id) {
      this.$router.push({
        name: 'couponDetail',
        query: {
          type: type,
          id: id
        }
      })

    },
    setting() {
      this.$router.push({
        name: 'settingPlatform',
        query: {}
      })
    }
  }
}
</script>
<style  lang="scss">
// .el-cascader-panel {
//   .el-scrollbar:first-child {
//     .el-checkbox {
//       display: none;
//     }
//   }
// }
</style>
<style scoped lang="scss">
::v-deep .el-form-item__error {
  left: 74px;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #2d46ee;
}

::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #2d46ee;
  background-color: #fff !important;
  border-color: #2d46ee;
  box-shadow: -1px 0 0 0 #2d46ee;
}

::v-deep .el-cascader-panel:first-child .el-checkbox {
  display: none !important;
}

::v-deep .el-cascader-panel li[aria-haspopup] .el-checkbox {
  display: none !important;
}

.container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 5px;
}

.title {
  // display: flex;
  // justify-content: space-between;
}

#base-list {
  margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.info {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  color: #303033;
  opacity: 1;
  text-align: center;
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.u-btn {
  width: 92px;
  height: 34px;
  background: #FFFFFF;
  border: 1px solid #2D46EE;
  opacity: 1;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 36px;
  color: #2D46EE;
  text-align: center;
  cursor: pointer;
  margin-right: 18px;
}

.c-btn {
  width: 106px;
  height: 36px;
  background: #FF9226;
  opacity: 1;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 36px;
  color: #FFFFFF;
  text-align: center;
  cursor: pointer;
  margin-right: 18px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 82px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 82px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>
  
  